// extracted by mini-css-extract-plugin
export default {"container":"Output_container__ZgC5E","label":"Output_label__W3RjT","text":"Output_text__JsJpP"};